export default {
  app: {
    ministry: "Ministry of Economy & Tourism",
    ministryShort: "MOET",
    platform: "National Competition Platform",
    platformShort: "NCP",
    department: "Competition Department",
    portalTitle: "External Services Portal",
    backofficeTitle: "Case Management",
    tagline: "Fair competition, transparent enforcement, investor confidence.",
    demoBadge: "Agentic AI demonstrator",
    language: "Language",
    english: "English",
    arabic: "العربية",
    switchToArabic: "العربية",
    switchToEnglish: "English",
    skipToContent: "Skip to main content",
    loading: "Loading…",
    poweredBy: "Powered by agentic AI with human-in-the-loop verification",
  },
  actions: {
    add: "Add",
    signIn: "Sign in",
    signInUaePass: "Sign in with UAE Pass",
    signOut: "Sign out",
    continue: "Continue",
    back: "Back",
    next: "Next",
    submit: "Submit",
    save: "Save",
    saveDraft: "Save draft",
    cancel: "Cancel",
    close: "Close",
    approve: "Approve",
    accept: "Accept",
    reject: "Reject",
    edit: "Edit",
    editAndApprove: "Edit & approve",
    requestRevision: "Request revision",
    view: "View",
    viewAll: "View all",
    download: "Download",
    upload: "Upload",
    search: "Search",
    filter: "Filter",
    refresh: "Refresh",
    retry: "Retry",
    send: "Send",
    copy: "Copy",
    copied: "Copied",
    saved: "Saved",
    start: "Start",
    apply: "Apply",
    confirm: "Confirm",
    delete: "Delete",
    escalate: "Escalate to a legal researcher",
    askAssistant: "Ask the assistant",
    explain: "Explain",
    openSource: "Open source",
    run: "Run",
    rerun: "Run again",
    pay: "Pay now",
    export: "Export",
    print: "Print",
    more: "More",
    less: "Less",
    showDetails: "Show details",
    hideDetails: "Hide details",
    complete: "Mark complete",
  },
  nav: {
    mainMenu: "Main menu",
    home: "Home",
    dashboard: "Dashboard",
    services: "Services",
    myCases: "My cases",
    publicRegister: "Public register",
    legalEnquiries: "Legal enquiries",
    thresholdTest: "Threshold self-assessment",
    notifications: "Notifications",
    organization: "Organisation",
    help: "Help",
    commandCenter: "Home",
    aiInbox: "AI Inbox",
    registers: "Registers",
    cases: "Cases",
    dataBank: "Data Bank",
    news: "News",
    marketStudies: "Market studies",
    legalKnowledge: "Legal knowledge",
    advocacy: "Advocacy",
    workflowStudio: "Workflow Studio",
    integrations: "Integrations",
    aiGovernance: "AI Governance",
    audit: "Audit & Security",
    settings: "Administration",
    platformConsole: "Platform Console",
    aiWorkspace: "AI Workspace",
    decisions: "Decision queue",
    investigations: "Investigations",
    committee: "Committee",
    economicConcentration: "Economic Concentration",
    investigationsComplaints: "Investigations & Complaints",
    otherRequests: "Other requests",
    statistics: "Statistics",
    resources: "Resources",
    work: "Casework",
    configured: "Department screens",
    exemptions: "Exemption applications",
    grievances: "Grievances",
    legalEnquiriesInternal: "Legal enquiries",
    outsideRequests: "Data and opinion requests",
  },
  caseTypes: {
    EconomicConcentration: "Economic concentration",
    Complaint: "Competition complaint",
    Exemption: "Exemption request",
    ExemptionAmendment: "Exemption amendment",
    Appeal: "Grievance / appeal",
    Whistleblowing: "Whistleblowing report",
    LegalEnquiry: "Legal enquiry",
    MarketStudy: "Market study",
    MarketDataRequest: "Respond to a market-study data request",
    TechnicalOpinion: "Technical opinion for the Ministry (G2G)",
    Generic: "Matter",
  },
  caseTypeDescriptions: {
    EconomicConcentration:
      "Notify a merger, acquisition or joint venture that meets the {{turnover}} turnover or {{share}} market-share threshold.",
    Complaint: "Report anti-competitive practices such as cartels, resale price maintenance or abuse of dominance.",
    Exemption: "Request an exemption for a restrictive agreement or dominant-position practice under Articles 5–8.",
    ExemptionAmendment: "Amend the scope or conditions of an exemption already granted.",
    Appeal: "Ask the Minister to reconsider a decision within 15 days of notification (Article 34).",
    Whistleblowing: "Confidentially report a suspected violation of the Competition Law.",
    LegalEnquiry: "Ask about Federal Decree-Law No. 36 of 2023 and its Implementing Regulations.",
    MarketStudy: "Independent study of a sector or market structure.",
    MarketDataRequest: "Answer the data and supporting documents the Ministry asks of your undertaking for a market study ({{marketDataBasis}}).",
    TechnicalOpinion: "For sector regulators and emirate authorities: give the technical opinion the Ministry requests on a complaint, an exemption or a concentration ({{opinionBasis}}).",
    Generic: "A department matter run by a configurable playbook.",
  },
  status: {
    Draft: "Draft",
    Submitted: "Submitted",
    UnderReview: "Under review",
    AwaitingApplicant: "Awaiting applicant response",
    Accepted: "Accepted",
    Rejected: "Rejected",
    Published: "Published",
    Investigation: "Under investigation",
    Decision: "Decision pending",
    Decided: "Decided",
    Closed: "Closed",
    Suspended: "Suspended",
    Withdrawn: "Withdrawn",
    Overdue: "Overdue",
    OnTrack: "On track",
    AtRisk: "At risk",
    Breached: "Breached",
    Completed: "Completed",
    Pending: "Pending",
    Paid: "Paid",
    Admissible: "Admissible",
    Inadmissible: "Inadmissible",
  },
  roles: {
    Applicant: "Applicant",
    Representative: "Authorised representative",
    EconomicResearcher: "Economic Researcher",
    LegalResearcher: "Legal Researcher",
    EconomicExpert: "Economic Expert",
    LegalExpert: "Legal Expert",
    HeadOfComplaints: "Head of Complaints Section",
    Director: "Director of Competition Department",
    AssistantUndersecretary: "Assistant Undersecretary, Commercial Control & Governance",
    Undersecretary: "Undersecretary",
    Minister: "Minister of Economy & Tourism",
    JudicialOfficer: "Judicial Officer",
    CommitteeMember: "Competition Regulation Committee member",
    Admin: "Platform administrator",
  },
  isic: "ISIC {{code}}",
  ai: {
    badge: "AI",
    pageRef: "p. {{n}}",
    assistant: "AI assistant",
    proposal: "AI proposal",
    proposals: "AI proposals",
    pendingReview: "Pending your review",
    confidence: "Confidence",
    citations: "Citations",
    citation: "Citation",
    reasoning: "Reasoning",
    explainability: "Why the AI suggests this",
    humanInLoop: "Requires human verification before any action is taken.",
    thinking: "Thinking…",
    retrieving: "Retrieving sources…",
    verifying: "Verifying citations…",
    saveAsGolden: "Save as golden case",
    revisionRequested: "Revision requested – the AI assistant is redrafting",
    recordedAsGolden: "Saved to the recorded-runs evaluation dataset",
    toolCall: "Using tool",
    drafting: "Drafting…",
    verified: "Verified by",
    approved: "Approved",
    edited: "Edited & approved",
    rejected: "Rejected",
    proposed: "Proposed",
    agentActivity: "AI assistant activity",
    modelUsed: "Model",
    tokens: "Tokens",
    guardrail: "Guardrail",
    piiRedacted: "PII redacted before model call",
    piiMasked: "{{count}} personal details masked",
    reviewedBy: "Reviewed by",
    guardrails: "Guardrail flags",
    disclaimer:
      "This assistant provides information, not legal advice. Every answer cites the source clause. For binding guidance, escalate to the Competition Department.",
    // Tables and charts from connected data sources (artifacts and proposals' source data).
    data: {
      source: "Source", retrieved: "retrieved {{date}}", sourceData: "Data from connected sources", sourceDataHint: "Figures the AI assistant pulled from connected systems; they are filed with the document as a workbook when approved.",
      table: "Table", chart: "Chart", rows: "Rows: {{count}}",
    },
    redlines: {
      title: "Proposed mark-up", count: "Clauses: {{count}}", highCount: "High risk: {{count}}",
      hint: "Clause by clause against the Ministry's standard positions: the current wording struck through, the proposed wording below it.",
      clause: "Clause {{n}}", current: "Current wording", proposed: "Proposed wording", notQuoted: "Current wording not quoted – check it against the contract.",
      rating: { high: "High", medium: "Medium", low: "Low" },
      showAll: "Show all {{count}} clauses", showFewer: "Show fewer",
    },
    figureCheck: {
      title: "Figure check", traced: "{{traced}} of {{total}} figures traced", penalty: "Confidence lowered by {{points}} points",
      hint: "Every figure of the draft matched against the statistics warehouse, the tools' results and the cited sources. Problems are listed first.",
      status: { Verified: "Verified", Rounded: "Rounded", Mismatch: "Differs from source", Unsupported: "Not traced", Stale: "Superseded release", PrecedenceBreach: "International figure as UAE figure" },
      expected: "Evidence gives {{value}}", matchedTo: "Traced to", allTraced: "Every figure is traced to its evidence.",
      showAll: "Show all {{count}} figures", showProblems: "Show problems only",
    },
    aiUse: {
      title: "AI-use record", prompt: "prompt", generated: "Drafted", tools: "Tools used", sources: "Sources", more: "and {{count}} more", checks: "Checks",
      citations: "citations {{value}}", quality: "quality {{value}}/100", review: "Human review",
      reviewText: "Advisory draft: it takes effect only when a named reviewer approves it. This record travels with the deliverable.",
      unsourced: "Statements of fact without a source (marked unsupported)",
    },
    // Approve / edit-and-approve / reject / revise flow, shared by every surface that reviews proposals.
    review: {
      draftSources: "Sources the draft cites",
      draftSourcesHint: "Open the sources the draft rests on before approving it.",
      reviewNote: "Review note (optional)",
      reviewNoteRequired: "Review note",
      editHintChanged: "Your edits will be recorded as feedback for the assistant's evaluation.",
      editHintNoChanges: "No changes yet.",
      reviseHint: "Tell the AI assistant what to change. The current draft is rejected with your note and the assistant redrafts immediately; the note also feeds future runs.",
      reviseNoteHint: "Be concrete: which section, which article, which figure. The assistant quotes your note back in its activity feed.",
      rejectNoteHint: "Why is this proposal not acceptable? Rejection notes are fed back to the AI assistant on its next runs.",
      reasonsTitle: "Your reasons for accepting the draft",
      reasonsLabel: "Your reasons",
      reasonsHint: "This draft bears on the outcome of the case. Say in your own words what you checked and what the finding rests on – at least {{count}} characters ({{typed}} so far); a passage copied from the draft is refused.",
      aiDraft: "The AI assistant's draft",
      yourVersion: "Your version — what will be approved",
      resetToDraft: "Discard your edits and start again from the assistant's draft",
      approveAndExecute: "Approve & execute",
      confirmTitle: "Approve and carry out the action?",
      confirmBody: "Approving carries out: {{action}}. It reaches the parties or the public record as soon as it is approved.",
      proposedAction: "Proposed action",
      manualRuns: "Manual / off-step runs",
    },
    redraft: {
      button: "Redraft with AI",
      title: "Redraft with AI",
      hint: "Say what needs changing. The assistant rewrites the text and shows it beside the current one — facts, figures and citations are kept, nothing is saved until you apply it.",
      instruction: "What needs changing?",
      instructionPlaceholder: "e.g. Shorter and more formal; say that the bank receipt for the filing fee is still missing; put the deficiencies first…",
      suggestions: {
        formal: "More formal",
        shorter: "Shorter",
        clearer: "Clearer and better structured",
        grammar: "Fix grammar and typos",
        translateAr: "Translate to Arabic",
        translateEn: "Translate to English",
        fromContext: "Write it for me from the criterion, my verdict and what the platform found",
      },
      run: "Redraft",
      rerun: "Try again",
      apply: "Apply redraft",
      applied: "Redraft applied — review it, then record or approve as usual",
      current: "Current text",
      proposed: "Proposed redraft",
      waiting: "The redraft appears here.",
      empty: "The text is empty — the assistant will write it from your instruction and the context.",
      showChanges: "Show changes",
      hideChanges: "Hide changes",
      unchanged: "The assistant returned the text unchanged. Try a more specific instruction.",
      offline: "AI redrafting is unavailable while the platform runs without a language model; edit the text by hand.",
      flags: "Instructions hidden inside the text were detected and ignored; read the result with care.",
      failed: "The redraft failed",
      meter: "{{ms}} ms",
    },
    // The AI Workspace conversation (<AssistantPanel>), embedded by every surface.
    chat: {
      placeholder: "Message {{assistant}}…",
      placeholderResearch: "Describe the question to research in depth…",
      disclaimer: "Answers are drafted by AI from the sources shown and can be wrong: check the citations. Nothing is sent, filed or decided without your confirmation.",
      attach: "Attach a document",
      attached: "Attached",
      uploading: "Uploading…",
      uploadFailed: "Could not attach {{name}}",
      removeAttachment: "Remove attachment",
      readingAttachment: "Uploading and reading…",
      attachmentQueued: "Waiting to upload",
      attachmentLimit: "Attach up to 5 files per message, each no larger than 200 MB.",
      resolveAttachments: "Wait for the uploads, then retry or remove any failed files before sending.",
      attachmentError: {
        interrupted: "The upload was interrupted. Your file is kept here; retry when ready.",
        tooLarge: "This file exceeds the 200 MB limit. Choose a smaller file.",
        empty: "This file is empty. Choose a file with content.",
        rejected: "This file could not be read. Remove it and choose a supported, readable file.",
      },
      stop: "Stop",
      retry: "Try again",
      copy: "Copy answer",
      copyMarkdown: "Copy as Markdown",
      sources: "Sources",
      regenerate: "Regenerate",
      copied: "Copied",
      helpful: "Helpful",
      notHelpful: "Not helpful",
      feedbackThanks: "Thank you — your feedback trains the evaluation set.",
      toolsUsed: "Tool calls: {{count}}",
      showTrace: "Show how this was produced",
      hideTrace: "Hide trace",
      stage: {
        thinking: "Thinking…",
        retrieving: "Retrieving sources…",
        tool: "Using tools…",
        delegating: "Handing over to a specialist…",
        verifying: "Verifying citations…",
        writing: "Writing…",
      },
      delegatedTo: "Delegated to {{agent}}",
      delegatedAsync: "{{agent}} is working in the background — the result will appear here and in your Inbox.",
      specialistReply: "{{agent}} (specialist)",
      runFailed: "The specialist run failed",
      proposalsPending: "Awaiting your review",
      artifact: "Artifact",
      artifactVersion: "v{{version}}",
      openArtifact: "Open",
      confirmTitle: "Confirmation needed",
      confirm: "Confirm",
      decline: "Decline",
      confirmExpires: "Expires {{when}}",
      confirmPendingHint: "This action changes records; it runs only after you confirm.",
      confirmFailed: "The action could not be completed",
      confirmEdit: "Edit",
      confirmDoneEditing: "Done editing",
      confirmStatus: { Pending: "Awaiting confirmation", Confirmed: "Running…", Executed: "Done", Declined: "Cancelled", Failed: "Failed", Expired: "Expired" },
      confirmArg: {
        title: "Title", summary: "Summary", note: "Note", category: "Category", playbook: "Playbook", priority: "Priority", parameters: "Details", matter: "Matter",
        move: "Move", from: "From", to: "To", task: "Task", answers: "Answers", then: "Then moves to", artifact: "Artifact", version: "Version", format: "Format",
        when: "When", onlyIf: "Only if", does: "What it does", reach: "For", nextRuns: "Next runs", reportsTo: "Reports to",
      },
      actionResult: "Action",
      openMatter: "Open matter",
      openWatcher: "Open watcher",
      openResult: "Open",
      offline: "Offline answer — the platform is running without a language model.",
      guardrail: "Guardrail: {{flag}}",
      error: "The assistant could not complete this turn.",
      emptyTitle: "How can I help today?",
      emptyHint: "Ask a question, research something in depth or start a process. Every answer shows its sources, and nothing that changes a record happens without your confirmation.",
      tryAsking: "Try asking",
      mention: "Address a specialist",
      mentionHint: "Your message goes to this specialist AI assistant",
      playbook: "Start a playbook",
      noMatches: "No matches",
      voice: "Voice input",
      listening: "Listening… click to stop",
      voiceUnsupported: "Voice input is not supported in this browser",
      viewSource: "Open the source document",
      viewCase: "Open case {{number}}",
      you: "You",
      newVersion: "New version",
      startProcess: "Start a process",
      startProcessHint: "Open a study or policy file that follows the Ministry's steps",
      askSpecialist: "Ask a specialist",
      askSpecialistHint: "Your next message goes to this specialist",
      toSpecialist: "To {{agent}}",
      clearMode: "Back to a normal question",
      modes: {
        label: "What would you like to do?",
        ask: "Ask a question",
        askHint: "A quick answer with its sources, from official statistics and the Ministry's papers.",
        research: "Research in depth",
        researchHint: "A specialist plans the sub-questions, reads the evidence and comes back with a cited brief. It takes a few minutes.",
        process: "Start a process",
        processHint: "Open a study or policy file that walks you through the Ministry's steps, from the question to the signed-off output.",
      },
      processBadge: "Process",
      noProcesses: "No processes are available here.",
      saveDraft: "Save as draft",
      savedDraft: "Saved to drafts and files",
      saveFailed: "The answer could not be saved",
      openDraft: "Open",
      details: "Details",
      detailsModel: "Model",
      detailsLatency: "Response time",
      detailsTokens: "Tokens in / out",
      detailsTools: "Tool calls",
      askedSpecialist: "Asked {{agent}}",
      workedSteps_one: "Worked through {{count}} step",
      workedSteps_other: "Worked through {{count}} steps",
      usedSources_one: "Used {{count}} source",
      usedSources_other: "Used {{count}} sources",
      artifactKind: { Markdown: "Document", Table: "Table", Chart: "Chart", Json: "Data", Docx: "Word", Pdf: "PDF", Xlsx: "Excel" },
    },
    // What a step of the assistant's work did, in plain words (`ai.tools.<tool key>`); `toolsActive` is the same step while it runs.
    tools: {
      agent_brief: "Read today's brief",
      agent_figures: "Read figures from the warehouse",
      agent_documents: "Searched the Knowledge Bank",
      agent_desks: "Read the desks' status",
      agent_decisions: "Read what is waiting for you",
      agent_country: "Read Country360",
      agent_draft: "Wrote a draft",
      agent_revise_draft: "Revised the draft",
      agent_suggest: "Added links and follow-ups",
      agent_plan: "Ran the plan",
      agent_team: "Consulted the team",
      agent_scenarios: "Ran the scenarios",
      agent_impact: "Read the impact lens",
      agent_study: "Wrote the study",
      search_knowledge: "Searched the Ministry's sources",
      search_regulations: "Searched the legislation",
      search_case_documents: "Searched the file's documents",
      search_precedents: "Looked for precedents",
      find_indicator: "Found the indicators",
      get_economic_series: "Read the official statistics",
      compare_economies: "Compared the UAE with other economies",
      economic_calc: "Did the calculations",
      source_guide: "Checked which source to use",
      target_gap: "Measured the gap to the national target",
      nowcast_non_oil_gdp: "Ran the experimental non-oil GDP nowcast",
      recent_publications: "Checked the latest releases",
      scenario_run: "Ran the scenarios",
      appraise_options: "Appraised the options",
      check_figures: "Checked the figures against the statistics warehouse",
      matter_assurance: "Read the file's assurance checks",
      matter_evidence: "Read the file's evidence",
      matter_kpis: "Read the file's indicators",
      matter_worksheet: "Read the file's worksheet",
      current_date: "Checked today's date",
      workspace_overview: "Looked over the workspace",
      list_matters: "Listed your files",
      get_matter: "Opened the file",
      create_matter: "Prepared a new file",
      fire_transition: "Prepared the file's next step",
      complete_task: "Completed a task",
      add_matter_note: "Added a note to the file",
      list_playbooks: "Looked up the processes",
      list_agents: "Looked up the specialists",
      delegate_to_agent: "Handed over to a specialist",
      draft_document: "Drafted a document",
      save_artifact: "Saved a draft",
      read_artifact: "Read a draft",
      list_artifacts: "Listed the drafts and files",
      file_artifact: "Filed a document",
      read_attachment: "Read the attachment",
      list_attachments: "Listed the attachments",
      list_watchers: "Looked at your alerts",
      propose_watcher: "Prepared an alert",
      list_workflows: "Looked up the workflows",
      propose_workflow_change: "Proposed a workflow change",
      request_information: "Prepared a request for information",
      find_case: "Found the case",
      list_my_cases: "Listed your cases",
      get_case_summary: "Read the case summary",
      get_market_shares: "Read the market shares",
      get_market_indicators: "Read the market indicators",
      compute_concentration: "Measured market concentration",
      lookup_establishment: "Looked up the company",
      search_deal_watch: "Searched the deal news",
      lookup_deal: "Looked up the deal",
      lookup_mergermarket_company: "Looked up the company in deal data",
      get_case_deal_intelligence: "Read the deal intelligence",
      case_market_economics: "Analysed the market",
      vertical_checklist: "Checked the vertical effects",
      assess_efficiencies: "Assessed the efficiencies",
      hypothetical_monopolist_test: "Ran the market definition test",
      pricing_pressure: "Measured the pricing pressure",
      simulate_merger: "Simulated the merger",
      local_catchments: "Mapped the local catchment areas",
      screen_tenders: "Screened the tenders",
      reconcile_shares: "Reconciled the market shares",
      ownership_graph: "Mapped the ownership",
      assess_notification_thresholds: "Checked the notification thresholds",
      calculate_fee: "Calculated the fee",
      working_days: "Counted the working days",
    },
    toolsActive: {
      agent_brief: "Reading today's brief",
      agent_figures: "Reading figures from the warehouse",
      agent_documents: "Searching the Knowledge Bank",
      agent_desks: "Reading the desks' status",
      agent_decisions: "Reading what is waiting for you",
      agent_country: "Reading Country360",
      agent_draft: "Writing a draft",
      agent_revise_draft: "Revising the draft",
      agent_suggest: "Adding links and follow-ups",
      agent_plan: "Running the plan",
      agent_team: "Consulting the team",
      agent_scenarios: "Running the scenarios",
      agent_impact: "Reading the impact lens",
      agent_study: "Writing the study",
      search_knowledge: "Searching the Ministry's sources",
      search_regulations: "Searching the legislation",
      search_case_documents: "Searching the file's documents",
      find_indicator: "Finding the indicators",
      get_economic_series: "Reading the official statistics",
      compare_economies: "Comparing the UAE with other economies",
      economic_calc: "Doing the calculations",
      target_gap: "Measuring the gap to the national target",
      recent_publications: "Checking the latest releases",
      scenario_run: "Running the scenarios",
      check_figures: "Checking the figures",
      delegate_to_agent: "Handing over to a specialist",
      draft_document: "Drafting the document",
    },
  },
  time: {
    days_one: "{{count}} day",
    days_other: "{{count}} days",
    workingDays_one: "{{count}} working day",
    workingDays_other: "{{count}} working days",
    daysLeft_one: "{{count}} day left",
    daysLeft_other: "{{count}} days left",
    daysOverdue_one: "{{count}} day overdue",
    daysOverdue_other: "{{count}} days overdue",
    dueOn: "Due {{date}}",
    startedOn: "Started {{date}}",
    justNow: "Just now",
    today: "Today",
    yesterday: "Yesterday",
    overdue: "Overdue",
  },
  conducts: {
    RestrictiveAgreement: "Restrictive agreement", Cartel: "Price fixing / cartel", ResalePriceMaintenance: "Resale price maintenance", BidRigging: "Bid rigging", MarketSharing: "Market sharing",
    AbuseOfDominance: "Abuse of dominance", PredatoryPricing: "Predatory pricing", EconomicDependency: "Abuse of economic dependency", ExclusiveDealing: "Exclusive dealing", RefusalToDeal: "Refusal to deal", Tying: "Tying / bundling",
    UnnotifiedConcentration: "Unnotified economic concentration", StandstillBreach: "Concentration implemented before clearance", Other: "Other",
  },
  misc: {
    inEnglish: "{{label}} (English)",
    inArabic: "{{label}} (Arabic)",
    type: "Type",
    laterPhase: "This module is delivered in a later phase of the build.",
    new: "New",
    active: "Active",
    caseNumber: "Case number",
    status: "Status",
    updated: "Updated",
    conditions: "Conditions",
    documents: "Documents",
    decision: "Decision",
    state: "Stage",
    risk: "Risk",
    reference: "Reference",
    createdAt: "Created",
    updatedAt: "Updated",
    assignedTo: "Assigned to",
    unassigned: "Unassigned",
    priority: "Priority",
    riskScore: "Risk score",
    sla: "Statutory deadline",
    noResults: "Nothing here yet",
    error: "Something went wrong",
    errorDetail: "The request could not be completed. Please try again.",
    aed: "AED",
    percent: "%",
    yes: "Yes",
    no: "No",
    optional: "Optional",
    required: "Required",
    all: "All",
    total: "Total",
    of: "of",
    page: "Page",
    rowsPerPage: "Rows per page",
    parties: "Parties",
    details: "Details",
    submittedAt: "Submitted",
    organization: "Organisation",
    timeline: "Timeline",
    none: "None",
    title: "Title",
    summary: "Summary",
    read: "Read",
    time: "Time",
    uploadedBy: "Uploaded by",
  },
  ec: {
    combinedTurnover: "Combined UAE turnover",
    combinedShare: "Combined market share",
    notifiable: "Notifiable",
    transactionType: "Transaction type",
    consideration: "Consideration",
    filingFee: "Filing fee",
    marketShares: "Market shares",
    relevantMarket: "Relevant market",
  },
  decisionOutcomes: {
    Approved: "Approved",
    ApprovedWithConditions: "Approved with conditions",
    Rejected: "Rejected",
    Prohibited: "Prohibited",
    NoInfringement: "No infringement",
    Infringement: "Infringement established",
    Exempted: "Exempted",
    ExemptedWithConditions: "Exempted with conditions",
    Withdrawn: "Withdrawn",
    Closed: "Closed",
    GrievanceAccepted: "Grievance accepted",
    GrievanceRejected: "Grievance rejected",
    ImplicitRejection: "Implicit rejection (30 days lapsed)",
    NotSubjectToNotification: "Not subject to notification",
    PrivateWarning: "Warning letter",
    AdministrativeFine: "Settlement proposal (Article 33(2))",
    ReferredToProsecution: "Criminal action requested (Article 33(1))",
  },
  enums: {
    proposalKind: {
      TriageMemo: "Triage memo", CompletenessReport: "Completeness report", DeficiencyNotice: "Deficiency notice", JurisdictionReport: "Jurisdiction report", LetterDraft: "Letter draft", MarketAnalysis: "Market analysis",
      InterestedPartyAnalysis: "Interested-party analysis", ObjectionAssessment: "Objection assessment", RecommendationReport: "Recommendation report", PreliminaryReport: "Preliminary report", FinalReport: "Final report",
      DecisionBrief: "Decision brief", InvestigationPlan: "Investigation plan", EvidenceAnalysis: "Evidence analysis", MeetingMinutes: "Meeting minutes", ComplianceAssessment: "Compliance assessment", CommitteeReport: "Committee report",
      EcInvestigationReport: "Concentration review report", AppealAssessment: "Appeal assessment", OfficialAnswer: "Official answer", MarketSignals: "Market signals", DataBankCuration: "Data Bank curation", MarketStudy: "Market study", WorkflowChange: "Workflow change", SlaAlert: "Deadline alert", DocumentProcessing: "Document processing",
      CompetitionAssessment: "Competition assessment", DataRequest: "Data request", DealWatch: "Deal screening", InternationalDigest: "International economic digest",
      EvidenceMatrix: "Evidence matrix", PolicyDraft: "Policy draft", HorizonScan: "Horizon scan", GrievanceAdmissibility: "Grievance admissibility", EconomicStudy: "Economic study", DataChangeReport: "Data change report", LegalOpinion: "Legal opinion", LitigationMemo: "Litigation memo", Report: "Report", PolicyNote: "Policy note", ResearchSynthesis: "Research synthesis", PositionPaper: "Position paper", ConceptNote: "Concept note", MinisterialResolution: "Ministerial resolution", PublicationDraft: "Publication draft", GrievanceAnalysis: "Grievance analysis", EvidenceReview: "Evidence review", ProfessionAnalysis: "Profession analysis", LegislationReview: "Legislation review", MatterDocument: "Matter document", ContractReview: "Contract review",
    },
    guardrail: {
      PromptInjection: "Prompt injection", DecisionLanguage: "Decision language", PiiLeak: "Personal data leak", MissingCitations: "Missing citations", UnknownCitation: "Unknown citation", NumberNotFromTool: "Number not from tool",
      LanguageMismatch: "Language mismatch", UnsupportedClaim: "Unsupported claim", SchemaViolation: "Schema violation", OutputTruncated: "Output truncated", TokenBudgetExceeded: "Token budget exceeded", QualityAttention: "Quality: needs attention",
      ArabicParity: "Arabic differs from the English", FigureCheck: "Figure check", ConfidenceLanguage: "No likelihood or confidence label", ArticleNotInCorpus: "Article not in the legal corpus", CitationUnverified: "Citation not judged",
      ModelUnavailable: "AI unavailable", ModelUnavailableBuilderFallback: "Made without AI", ModelUnavailableSuperAgentFallback: "Composed without AI", FabricationDeclined: "Request to invent data declined", UndatedFigure: "Figure without a date",
      UnsourcedStatement: "Statement without a source",
      FreshnessNotChecked: "Not checked against the latest official sources",
    },
    documentCategory: {
      Decision: "Decision", TransactionAgreement: "Transaction agreement", FinancialStatements: "Financial statements", MarketReport: "Market report", OrgChart: "Ownership chart", PowerOfAttorney: "Power of attorney", OverlapAnalysis: "Overlap analysis", PublicSummary: "Public summary",
      Efficiencies: "Efficiencies", Agreement: "Agreement", ComplainantIdentity: "Complainant identity", ConductEvidence: "Evidence of conduct", HarmEvidence: "Evidence of harm", MarketPosition: "Market position", MarketInformation: "Market information",
      PricingEvidence: "Pricing evidence", EssentialGoodsEvidence: "Essential goods evidence", PartyResponse: "Party response", Report: "Report", Other: "Other",
    },
    letterKind: {
      Acknowledgement: "Acknowledgement", DeficiencyNotice: "Deficiency notice", RequestForInformation: "Request for information", Reminder: "Reminder", Warning: "Warning", AcceptanceNotice: "Acceptance notice", RejectionNotice: "Rejection notice",
      PublicationNotice: "Publication notice", InvitationToComment: "Invitation to comment", ObjectionNotice: "Objection notice", MeetingInvitation: "Meeting invitation", ReportShare: "Report shared", DecisionNotice: "Decision notice", ExtensionNotice: "Extension notice", General: "General",
    },
    channel: { PortalInbox: "Portal inbox", Email: "Email", Sms: "SMS", OfficialLetter: "Official letter" },
    letterStatus: { Draft: "Draft", PendingApproval: "Pending approval", Approved: "Approved", Sent: "Sent", Delivered: "Delivered", Failed: "Failed", Cancelled: "Cancelled" },
    submitterType: { Competitor: "Competitor", Customer: "Customer", Supplier: "Supplier", Distributor: "Distributor", Association: "Trade association", Regulator: "Sector regulator", Consumer: "Consumer", Other: "Other" },
    partyRole: {
      NotifyingParty: "Notifying party", AcquiringParty: "Acquiring party", TargetParty: "Target", JointVenturePartner: "Joint-venture partner", Complainant: "Complainant", Respondent: "Respondent", InterestedParty: "Interested party", Objector: "Objector",
      Applicant: "Applicant", Representative: "Representative", Whistleblower: "Whistleblower", Other: "Other",
    },
    classification: { Public: "Public", Internal: "Internal", Confidential: "Confidential", Secret: "Secret" },
    extractionStatus: { Pending: "Waiting to be read", Processing: "Being read", Completed: "Read", Failed: "Could not be read" },
    band: { Unconcentrated: "Unconcentrated", ModeratelyConcentrated: "Moderately concentrated", HighlyConcentrated: "Highly concentrated" },
    readiness: { Complete: "Complete", Partial: "Partial", Missing: "Missing", Optional: "Optional", Present: "Present", Deficient: "Deficient", NotRequired: "Not required" },
    signalKind: { Info: "Information", Warning: "Warning", Error: "Error", Tip: "Tip", NewsMention: "News mention", PriceParallelism: "Price parallelism", ResalePriceSignal: "Resale price signal", ShareJump: "Share jump", TenderPattern: "Tender pattern" },
    signalStatus: { New: "New", Escalated: "Escalated", Dismissed: "Dismissed" },
    evidenceDirection: { Supports: "Supports", Contradicts: "Contradicts", Neutral: "Neutral" },
    stance: { Support: "Support", Concern: "Concern", Oppose: "Oppose", Neutral: "Neutral" },
    objectionOutcome: { Open: "Open", Upheld: "Upheld – weighed in the review", Dismissed: "Dismissed", Admissible: "Admissible", Inadmissible: "Inadmissible", Pending: "Pending" },
    meetingKind: { Hearing: "Hearing", FieldVisit: "Field visit", Consultation: "Consultation" },
    transactionType: { Merger: "Merger", Acquisition: "Acquisition of control", JointVenture: "Full-function joint venture", AssetTransfer: "Transfer of assets", ControlChange: "Change from joint to sole control", Agreement: "Agreement", MinorityStake: "Minority stake" },
    paymentStatus: { Pending: "Awaiting payment", Paid: "Paid", Failed: "Payment failed", Refunded: "Refunded", Waived: "Waived", Reversed: "Payment reversed", RefundPending: "Refund awaiting confirmation" },
    dataSourceKey: {
      registry: "National Economic Register", fcsc: "Federal Competitiveness and Statistics Centre", mof: "Ministry of Finance", casefiling: "Case filings", marketfeed: "Market intelligence feed",
      cbuae: "Central Bank of the UAE", cma: "Capital Market Authority", dfsa: "Dubai Financial Services Authority", "ner-g2g": "National Economic Register – government link",
      "moet-ubo": "Ministry beneficial owner and partner records", "moet-agencies": "Ministry commercial agencies register", "moet-ec-register": "Ministry register of concentration decisions",
      fta: "Federal Tax Authority", mohre: "Ministry of Human Resources and Emiratisation", moiat: "Ministry of Industry and Advanced Technology", "icp-customs": "Federal Authority for Identity, Citizenship, Customs and Port Security",
      "mof-procurement": "Ministry of Finance digital procurement platform", "tdra-telecom": "Telecommunications and Digital Government Regulatory Authority", ubo: "Beneficial owner data",
      fsra: "ADGM Financial Services Regulatory Authority", gcaa: "General Civil Aviation Authority", moei: "Ministry of Energy and Infrastructure", "mohap-ede": "Ministry of Health and Prevention and Emirates Drug Establishment",
      "dha-doh": "Dubai Health Authority and Abu Dhabi Department of Health", "khda-adek": "KHDA and Abu Dhabi Department of Education and Knowledge", "dld-adrec": "Dubai Land Department and Abu Dhabi Real Estate Centre",
      "dubai-det": "Dubai Department of Economy and Tourism", "abudhabi-adra": "Abu Dhabi Department of Economic Development", "sharjah-sedd": "Sharjah Economic Development Department",
      "northern-deds": "Economic development departments of Ajman, Ras Al Khaimah, Fujairah and Umm Al Quwain", bayanat: "National open data platform", wam: "Emirates News Agency",
      aecb: "Al Etihad Credit Bureau", chambers: "Dubai and Abu Dhabi chambers of commerce", mergermarket: "Mergermarket",
    } as Record<string, string>,
    agreementType: { Horizontal: "Horizontal agreement", Vertical: "Vertical agreement", JointPurchasing: "Joint purchasing", "R&D": "Research and development", Standardisation: "Standardisation", Other: "Other" },
    overlapType: { Horizontal: "Horizontal", Vertical: "Vertical", Conglomerate: "Conglomerate", None: "None" },
    proposalStatus: { Proposed: "Proposed", Approved: "Approved", Edited: "Edited & approved", Rejected: "Rejected", Superseded: "Superseded", Expired: "Expired" },
    runStatus: { Queued: "Queued", Running: "Running", Succeeded: "Succeeded", Failed: "Failed", Cancelled: "Cancelled" },
    stepKind: { Started: "Started", Thought: "Reasoning", Retrieval: "Retrieval", ToolCall: "Tool call", ToolResult: "Tool result", Draft: "Draft", Guardrail: "Guardrail", Token: "Token", Completed: "Completed", Failed: "Failed" },
    integrationHealth: { Healthy: "Healthy", Degraded: "Degraded", Down: "Down", Unknown: "Unknown" },
    dataSource: { CaseFiling: "Case filing", FCSC: "FCSC statistics", Registry: "National Economic Register", MOF: "Ministry of Finance", MarketStudy: "Market study", Manual: "Manual entry" },
    corpusKind: { Law: "Law", CabinetDecision: "Cabinet decision", MinisterialDecision: "Ministerial decision", Guideline: "Guideline", Procedure: "Procedure", Precedent: "Precedent", ComparativeReference: "Comparative reference", Faq: "FAQ", Report: "Report", Policy: "Policy", InternationalGuidance: "International guidance", Agreement: "Agreement", Strategy: "Strategy", Statistics: "Statistics", Methodology: "Methodology", Study: "Study", Opinion: "Legal opinion", Briefing: "Briefing", Paper: "Paper", Framework: "Framework", Minutes: "Minutes", Feedback: "Feedback", Presentation: "Presentation" },
    triggerSource: { Workflow: "Workflow", Manual: "Manual", Revision: "Revision", Schedule: "Schedule", Chat: "Chat", Delegation: "Delegation" },
    priority: { Low: "Low", Medium: "Medium", High: "High", Critical: "Critical" },
    slaHealth: { OnTrack: "On track", AtRisk: "At risk", Breached: "Breached", Completed: "Completed", Paused: "Paused" },
    workflowState: {
      RemedyDesign: "Remedy design and market test", UndersecretaryDecision: "Under-Secretary's decision on notifiability", PenaltyRecommendation: "Outcome recommendation",
      Draft: "Draft", PreNotification: "Pre-notification discussion", Received: "Received", FormalReview: "Initial review", AwaitingCompletion: "Awaiting completion", Registered: "Registered", SimplifiedReview: "Simplified review", SubstantiveReview: "Substantive review", PartyMeetings: "Meetings with parties", PreliminaryFindings: "Preliminary findings – parties' reply",
      Publication: "Published for comments", ObjectionsReview: "Objections review", Assessment: "Assessment report", CommitteeOpinion: "Before the Competition Regulation Committee", Escalation: "Escalated to the Minister", MinisterDecision: "Minister's decision", Decided: "Decided", Closed: "Closed", Withdrawn: "Withdrawn",
      FormalCheck: "Formal check", AwaitingComplainant: "Awaiting complainant", RejectOrSuspend: "Reject or suspend", PartiesNotification: "Parties notified", Investigation: "Investigation", PreliminaryReportShared: "Preliminary report shared", FinalReport: "Final report",
      Rejected: "Rejected", Suspended: "Suspended", MinisterReview: "Minister's review", Accepted: "Accepted", AwaitingApplicant: "Awaiting applicant", ComplianceReview: "Compliance review", CommitteeReview: "Committee review", AmendmentReview: "Amendment review",
      InformationGathering: "Information gathering", ReportPreparation: "Report preparation", Dismissed: "Dismissed", Open: "Open", Escalated: "Escalated", Answered: "Answered",
      Screening: "Under screening", Returned: "Returned – not notifiable",
      Commissioned: "Commissioned", Scoping: "Scoping", DataCollection: "Collecting data", Analysis: "Under analysis", Consultation: "Consultation open", Drafting: "Drafting the report", Review: "Under approval", Published: "Published", Monitoring: "Monitoring",
    },
    commitmentKind: { Structural: "Structural", Behavioural: "Behavioural", Reporting: "Reporting", Performance: "Performance" },
    commitmentStatus: { Pending: "Pending", InProgress: "In progress", Met: "Met", Breached: "Breached", Waived: "Waived" },
    decisionOutcome: {
      Approved: "Approved", ApprovedWithConditions: "Approved with conditions", Rejected: "Rejected", Prohibited: "Prohibited", NoInfringement: "No infringement", Infringement: "Infringement established",
      Exempted: "Exempted", ExemptedWithConditions: "Exempted with conditions", Withdrawn: "Withdrawn", Closed: "Closed", GrievanceAccepted: "Grievance accepted", GrievanceRejected: "Grievance rejected", ImplicitRejection: "Implicit rejection", NotSubjectToNotification: "Not subject to notification",
    },
    sector: {
      "Retail – grocery": "Retail – grocery", "Manufacturing – cement and building materials": "Manufacturing – cement and building materials", "Pharmaceuticals and healthcare": "Pharmaceuticals and healthcare", Telecommunications: "Telecommunications",
      "Transport and logistics": "Transport and logistics", "Construction and contracting": "Construction and contracting", "Food and beverages": "Food and beverages", "Education services": "Education services", "Financial services": "Financial services", Other: "Other",
    },
  },
  ui: {
    close: "Close", you: "You", showDraft: "Show draft & citations", hideDraft: "Hide draft", noResults: "No results", previousPage: "Previous page", nextPage: "Next page", switchLanguage: "Switch language", toggleNavigation: "Toggle navigation",
    moderatelyConcentrated: "Moderately concentrated", highlyConcentrated: "Highly concentrated", cardNumber: "Card number", quality: "Quality",
  },
  sso: {
    heading: "Sign in with your organisation account",
    continueWith: "Continue with {{name}}",
    redirecting: "Redirecting to {{name}}…",
    completing: "Completing sign-in…",
    startFailed: "The sign-in could not be started.",
    protectedNote: "Ministry staff accounts sign in with their own password; accounts are issued by the administrator.",
    errors: {
      noRole: "You signed in, but none of your directory groups gives you a role on the platform. Ask an administrator to map your group or grant you a role.",
      notProvisioned: "Your directory account has no platform account yet. Ask an administrator to add you.",
      deactivated: "Your platform account is deactivated. Contact an administrator.",
      emailDomainNotAllowed: "Accounts from your e-mail domain cannot sign in here.",
      linkConflict: "An administrator must allow this account to be linked to your Ministry account.",
      mfa_not_performed: "Your Ministry account sign-in did not include the authenticator step. Sign in again.",
      mfa_reauthenticate: "Your Ministry account sign-in is older than this platform accepts. Sign in again.",
      state_invalid: "This sign-in expired or was already used. Start again.",
      access_denied: "The sign-in was cancelled.",
      provider_unavailable: "The Ministry account sign-in is not available right now.",
      generic: "The sign-in did not complete.",
    },
  },
  /** Strict sign-in, sessions and accounts (security §14.3, with SPEC C13: no recovery codes; C42: 14 characters). Shared by every staff app. */
  auth: {
    title: "Sign in",
    login: "Work e-mail or username",
    password: "Password",
    passwordPlaceholder: "Your password",
    continue: "Continue",
    showPassword: "Show password",
    hidePassword: "Hide password",
    capsLockOn: "Caps Lock is on",
    capsLockOff: "Caps Lock is off",
    forgot: "Forgot your password?",
    forgotHint: "Your administrator resets it",
    ministry: "Sign in with Ministry account",
    passwordInstead: "Sign in with password instead",
    hidePasswordSignIn: "Hide password sign-in",
    loadingSignInOptions: "Loading sign-in options…",
    or: "or",
    noSelfSignup: "No self-registration and no shared links. Accounts are issued by the Digital Transformation administrator; 5 failed attempts lock the account for 15 minutes.",
    signedIn: "Signed in",
    code: {
      title: "Authentication code",
      label: "6-digit code from your authenticator app",
      every: "A new code every 30 seconds",
      verify: "Verify and sign in",
      verified: "Password verified",
      notYou: "Not you?",
      lost: "Lost your device?",
      lostHint: "The DT Service Desk re-enrols you after checking your identity",
    },
    change: {
      title: "Set a new password",
      hint: "Your administrator issued a temporary password. Choose your own to continue.",
      new: "New password",
      confirm: "Confirm new password",
      rule: "At least 14 characters. A passphrase of several words is easiest to remember.",
      submit: "Save and continue",
    },
    rules: {
      title: "Password rules",
      length: "At least 14 characters",
      notReused: "Not one of your last 5 passwords",
      notBreached: "Not on breached-password lists",
      noName: "Without your name or e-mail",
      match: "Both entries match",
      server: "Checked by the server when you continue",
    },
    enrol: {
      title: "Set up your authenticator",
      scan: "Scan with your authenticator app",
      hint: "Microsoft Authenticator, Google Authenticator or any TOTP app. The code changes every 30 seconds.",
      qrAlt: "QR code for your authenticator app",
      manual: "Can’t scan? Show the setup key",
      hideKey: "Hide the setup key",
      key: "Setup key",
      account: "Account",
      copy: "Copy",
      copied: "Copied",
      confirm: "Enter the 6-digit code to confirm",
      submit: "Confirm and finish",
      preparing: "Preparing your authenticator code…",
      private: "Your administrator cannot see your password or your authenticator secret. Enrolment is recorded in the audit log.",
    },
    err: {
      invalid_credentials: "The e-mail or password is not correct, or the account is temporarily locked.",
      attemptsLeft: "Attempts left before a 15-minute lock: {{count}}",
      rate_limited: "Too many attempts. Wait a few minutes and try again.",
      mfa_invalid: "That code is not correct. Check the time on your phone and try the newest code.",
      codeAttemptsLeft: "Code attempts left on this sign-in: {{count}}",
      mfa_not_enrolled: "No authenticator is set up for this account. Your administrator can reset it.",
      mfa_code_reused: "This code was already used. Wait for the next code.",
      challenge_expired: "This sign-in took too long. Start again.",
      password_policy: "The new password does not meet the password rules.",
      password_too_short: "The password is too short (at least 14 characters).",
      password_too_long: "The password is too long (at most 128 characters).",
      password_invalid_characters: "The password contains characters that cannot be used.",
      password_common: "This password is common or has appeared in breaches. Choose another.",
      password_contains_identity: "The password must not contain your name or e-mail.",
      password_reused: "You cannot reuse one of your last 5 passwords.",
      password_mismatch: "The passwords do not match.",
      mfa_not_performed: "Your Ministry account sign-in did not include the authenticator step. Sign in again.",
      mfa_reauthenticate: "Your Ministry account sign-in is older than this platform accepts. Sign in again.",
      code_incomplete: "Enter all 6 digits of the code.",
      network: "The server could not be reached. Check the connection and try again.",
      unavailable: "Password sign-in is not available on this server yet.",
      generic: "The sign-in did not complete. Try again.",
    },
    lastSignIn: "Last sign-in: {{when}} from {{where}}",
    notice: {
      password_reset_by_admin: "Your password was reset by {{name}} on {{date}}.",
      mfa_reset_by_admin: "Your authenticator was reset by {{name}} on {{date}}.",
      dismiss: "Dismiss",
    },
    session: {
      idleTitle: "Still there?",
      idleWarning: "For security you will be signed out in {{time}} because of inactivity.",
      absoluteTitle: "Your session is ending",
      absoluteWarning: "Your session ends at {{time}}. Save your work; you will need to sign in again.",
      stay: "Stay signed in",
      signOut: "Sign out",
      signOutNow: "Sign out now",
    },
    reason: {
      idle: "You were signed out after 30 minutes of inactivity.",
      expired: "Your session reached its 10-hour limit. Sign in again.",
      revoked: "Your session was ended by an administrator or from another device.",
      ended: "Your session ended. Sign in again.",
      other_tab: "You signed out in another tab.",
    },
    sessions: {
      title: "Signed-in devices",
      current: "This device",
      revoke: "Sign out this device",
    },
    portal: {
      subtitle: "Applicants and their representatives sign in with the UAE Pass account linked to their Emirates ID.",
      uaePassOff: "UAE Pass sign-in is not connected in this environment.",
      uaePassOffHint: "Applicants sign in with UAE Pass once the Ministry connects it. Until then this page offers no other way in.",
      emailCode: "Sign in with a code sent to your e-mail",
      emailCodeHint: "For undertakings and counsel without a UAE Pass identity; the Ministry enables it per environment.",
    },
  },
} as const;
